import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { UserLibService } from '../../service/user/user-lib.service';
import { Router } from '@angular/router';
import { GrpcAuthenLibService } from '../../service/grpc/authen/grpc-authen-lib.service';
import { SignUpMobileRequest } from '../../libs/proto/mobile_pb';
import { SignupForm } from '../../class/signup/signup';
import { DialogServiceService } from '../../service/dialog/dialog-service.service';
import { Customer } from '../../libs/proto/commUnity_pb';
import { GrpcCustomerLibService } from '../../service/grpc/customer/grpc-customer-lib.service';
import { ErrorStateMatcher } from '@angular/material/core';
import { FormControl, FormGroupDirective, NgForm } from '@angular/forms';
export class EmailErrorMatcher implements ErrorStateMatcher {
  isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const emailok = (control.value || '').match(/^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/g)
    return !!(control && (control.invalid || !emailok) && (control.dirty || control.touched));
  }
}
@Component({
  selector: 'app-signup',
  templateUrl: './signup.component.html',
  styleUrls: ['./signup.component.sass']
})
export class SignupComponent implements OnInit {

  Loading: boolean;
  logoURL: string;
  bgURL: string;

  signupOK = false;
  signupForm: SignupForm;

  email_matcher = new EmailErrorMatcher();

  constructor(
    private translate: TranslateService,
    private router: Router,
    private grpcAuthLib: GrpcAuthenLibService,
    private grpcCusLib: GrpcCustomerLibService,
    private alertLib: DialogServiceService
  ) {
    let lg = (window.navigator.language || 'en').substr(0, 2);
    if (location.href.match(/lg=fr/gi)) { lg = 'fr'; }
    this.translate.use(lg || 'en');

  }

  validateCustomer(): Promise<Customer>{
    const thise = this;
    return new Promise<Customer>( (ok, ko) => {
      thise.grpcCusLib.getCustomer().then( c => {
        ok(c);
      }).catch( e => {
        ko(e);
      });

    });
  }

  ngOnInit(): void {
    const thise =  this;
    this.signupForm = new SignupForm();
    this.validateCustomer().then( c => {

      thise.signupForm.customerId = c.getId();

    });
  }

  back() {
    this.router.navigateByUrl('/login');
  }

  save() {
    const thise = this;
    this.translate.get([
      'signup.signup_msg_title',
      'signup.signup_ok',
      'signup.signup_member_exist',
      'signup.signup_ko']).toPromise().then( t => {
        thise.grpcAuthLib.signUp(this.signupForm.toSignUpMobileRequest()).then( v => {

          thise.signupOK = true;

        }).catch( e => {
          if ((e.message || '') === 'member already exists in database') {
            thise.alertLib.show(t['signup.signup_member_exist'],
                  t['signup.signup_msg_title']);
          } else {
            thise.alertLib.show(t['signup.signup_ko'],
                  t['signup.signup_msg_title']);
          }
        });

    });
  }

  get validAccount(): boolean {
    return ((this.signupForm.firstName || '') !== '') &&
           ((this.signupForm.lastName || '') !== '') &&
           ((this.signupForm.email || '') !== '') &&
           ((this.signupForm.mobile || '') !== '');
  }
  close_signup() {
    this.signupOK = false;
    this.router.navigateByUrl('/login');
  }
}
